<template>
  <div class="campus-nothing-container flex-column-center">
    <img src="https://files.wondercv.com/m/calendar/no-data.png" alt="">
    <span>{{ dealType === 'me' ? '暂无待办事项' : '暂无网申日程' }}</span>
    <!-- <button class="theme-button flex-center" @click="addThings">{{ dealType === 'me' ? '新建待办' : '更多校招' }}</button> -->
  </div>
</template>

<script>
  export default {
   props: {
     dealType: {
       type: String,
       default: 'me'
     }
   },
   data(){
     return {
     }
   },
   mounted () {},
   components:{},
   watch:{},
   computed:{},
   methods:{
     addThings() {
       this.$emit('addThings')
     }
   }
  }
</script>
<style scoped lang="scss">
@import '../../../assets/scss/global/variable';
@import '../../../assets/scss/global/mixin';
.campus-nothing-container {
  // padding-top: 140px;
  img {
    width: 74px;
    margin-bottom: 18px;
  }
  span {
    color: #9C9C9C;
    line-height: 20px;
    margin-bottom: 24px;
  }
  button {
    width: 120px;
    height: 36px;
    background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);
    border-radius: 22px;
    font-size: $font-size-medium;
  }
}
</style>